import React from 'react'
import Manager from '../../public/components/Manager'
import OverTimeApplyDetail from './OverTimeApplyDetail'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        当年: {
            export: true,
            exportColumns: [
                { _text: '申请编号', field: 'Number', minWidth: 200, search: true, },
                { _text: '加班折算方式', field: 'ConversionMode', minWidth: 200, search: true, filter: ['select'], },
                { _text: '申请人', field: 'Creator', minWidth: 200, search: true, },
                { _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 200, filter: true, align: 'left', },
                { _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
                { _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
                { _text: '加班原因', field: 'Reason', minWidth: 150, flex: 2, search: true },
                { _text: '加班类型', field: '_OverTimeType', minWidth: 150, flex: 1, },
                { _text: '申请部门', field: '_CreateDep', minWidth: 150, search: true, flex: 5, },
                { _text: '状态', field: 'StatusName', minWidth: 150, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            buttons: [
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 200, search: true, },
                { _text: '加班折算方式', field: 'ConversionMode', minWidth: 200, search: true, filter: ['select'], },
                { _text: '申请人', field: 'Creator', minWidth: 200, search: true, },
                { _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 200, filter: true, align: 'left', },
                { _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
                { _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
                { _text: '加班原因', field: 'Reason', minWidth: 150, flex: 2, search: true },
                { _text: '加班类型', field: '_OverTimeType', minWidth: 150, flex: 1, },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, search: true, flex: 5, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
                { _text: '状态', field: 'StatusName', minWidth: 150, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <OverTimeApplyDetail {...props} id={data.id} readOnly={true} />)
            }
        },
        全部: {
            export: true,
            exportColumns: [
                { _text: '申请编号', field: 'Number', minWidth: 200, search: true, },
                { _text: '加班折算方式', field: 'ConversionMode', minWidth: 200, search: true, filter: ['select'], },
                { _text: '申请人', field: 'Creator', minWidth: 200, search: true, },
                { _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 200, filter: true, align: 'left', },
                { _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
                { _datetime: '加班确认时间', field: 'OverTimeConfirmationTime', minWidth: 150, filter: true, align: 'left', },
                { _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
                { _text: '加班原因', field: 'Reason', minWidth: 150, flex: 2, search: true },
                { _text: '加班类型', field: '_OverTimeType', minWidth: 150, flex: 1, },
                { _text: '申请部门', field: '_CreateDep', minWidth: 150, search: true, flex: 5, },
                { _text: '状态', field: 'StatusName', minWidth: 150, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            buttons: [
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 200, search: true, },
                { _text: '加班折算方式', field: 'ConversionMode', minWidth: 200, search: true, filter: ['select'], },
                { _text: '申请人', field: 'Creator', minWidth: 200, search: true, },
                { _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 200, filter: true, align: 'left', },
                { _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
                { _datetime: '加班确认时间', field: 'OverTimeConfirmationTime', minWidth: 150, filter: true, align: 'left', },
                { _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
                { _text: '加班原因', field: 'Reason', minWidth: 150, flex: 2, search: true },
                { _text: '加班类型', field: '_OverTimeType', minWidth: 150, flex: 1, },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, search: true, flex: 5, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
                { _text: '状态', field: 'StatusName', minWidth: 150, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <OverTimeApplyDetail {...props} id={data.id} readOnly={true} />)
            }
        }
    }
}

export default props => <Manager {...props} config={config} />